// ENGEL & LOEWE – Luxury Interactive Experience V9
// Mayfair Theme Compatible – display:none fix + banner button hover isolation

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('[ENGEL LOEWE] V9 – Initializing...');

    initScrollReveal();
    initCursor();
    initMarquee();
    initBackToTop();
    initPageTransitions();
    initBannerButtonHover();
    initNavGoldUnderline();

    console.log('[ENGEL LOEWE] V9.2 – All modules initialized.');
  }


  // ========================================================
  // HELPER: Force styles via setProperty to beat theme CSS
  // The Mayfair theme sets display:none on unknown elements.
  // We must use element.style.setProperty with !important.
  // ========================================================

  function forceStyle(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }


  // ========================================================
  // 1. SCROLL REVEAL ANIMATIONS
  // ========================================================

  function initScrollReveal() {
    var selectors = [
      '.section-container',
      '.section-header',
      '.section-inner',
      '.image-with-text-footer',
      '.col-grid-wrapper',
      '.collection-cards-section .card-wrapper',
      '.sub-footer-section'
    ];

    var elements = document.querySelectorAll(selectors.join(', '));
    console.log('[ENGEL LOEWE] Reveal elements found:', elements.length);

    var bannerParents = [
      '.landing-screen-section',
      '.banner-full-bleed',
      '.section-video-banner',
      '.section-image-banner'
    ];

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('el-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -20px 0px'
      });

      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        var inBanner = false;
        for (var j = 0; j < bannerParents.length; j++) {
          if (el.closest(bannerParents[j])) {
            inBanner = true;
            break;
          }
        }
        if (!inBanner) {
          observer.observe(el);
        } else {
          el.classList.add('el-revealed');
        }
      }
    } else {
      for (var k = 0; k < elements.length; k++) {
        elements[k].classList.add('el-revealed');
      }
    }
  }


  // ========================================================
  // 2. CUSTOM GOLD CURSOR
  // All styles set via setProperty to override theme CSS.
  // ========================================================

  function initCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      console.log('[ENGEL LOEWE] Cursor: skipped (touch device)');
      return;
    }

    var cursor = document.createElement('div');
    cursor.id = 'el-luxury-cursor';
    document.body.appendChild(cursor);

    // Force ALL styles via setProperty – theme cannot override these
    forceStyle(cursor, 'display', 'block');
    forceStyle(cursor, 'position', 'fixed');
    forceStyle(cursor, 'width', '12px');
    forceStyle(cursor, 'height', '12px');
    forceStyle(cursor, 'background-color', '#C9A961');
    forceStyle(cursor, 'border-radius', '50%');
    forceStyle(cursor, 'pointer-events', 'none');
    forceStyle(cursor, 'z-index', '2147483647');
    forceStyle(cursor, 'opacity', '0');
    forceStyle(cursor, 'top', '0');
    forceStyle(cursor, 'left', '0');
    forceStyle(cursor, 'transform', 'translate(-50%, -50%)');
    forceStyle(cursor, 'transition', 'opacity 0.3s ease, width 0.3s ease, height 0.3s ease, background-color 0.3s ease');
    forceStyle(cursor, 'box-sizing', 'border-box');
    forceStyle(cursor, 'margin', '0');
    forceStyle(cursor, 'padding', '0');

    console.log('[ENGEL LOEWE] Cursor: created with forced inline styles');
    console.log('[ENGEL LOEWE] Cursor: computed display =', getComputedStyle(cursor).display);

    var posX = 0;
    var posY = 0;
    var targetX = 0;
    var targetY = 0;
    var isVisible = false;
    var isHovering = false;

    document.addEventListener('mousemove', function(e) {
      targetX = e.clientX;
      targetY = e.clientY;
      if (!isVisible) {
        forceStyle(cursor, 'opacity', '1');
        isVisible = true;
      }
    });

    function animate() {
      posX += (targetX - posX) * 0.15;
      posY += (targetY - posY) * 0.15;
      cursor.style.left = posX + 'px';
      cursor.style.top = posY + 'px';
      requestAnimationFrame(animate);
    }
    animate();

    var hoverTargets = 'a, button, [role="button"], input, select, textarea, .card-wrapper, .product-card, summary, .nav-desktop-dd-btn, .hdr-menu-button, .image-banner-full-banner-link, label';

    document.addEventListener('mouseover', function(e) {
      if (e.target.closest(hoverTargets)) {
        if (!isHovering) {
          forceStyle(cursor, 'width', '40px');
          forceStyle(cursor, 'height', '40px');
          forceStyle(cursor, 'background-color', 'rgba(201, 169, 97, 0.2)');
          isHovering = true;
        }
      }
    });

    document.addEventListener('mouseout', function(e) {
      if (e.target.closest(hoverTargets)) {
        if (isHovering) {
          forceStyle(cursor, 'width', '12px');
          forceStyle(cursor, 'height', '12px');
          forceStyle(cursor, 'background-color', '#C9A961');
          isHovering = false;
        }
      }
    });

    document.addEventListener('mouseleave', function() {
      forceStyle(cursor, 'opacity', '0');
      isVisible = false;
    });

    document.addEventListener('mouseenter', function() {
      forceStyle(cursor, 'opacity', '1');
      isVisible = true;
    });
  }


  // ========================================================
  // 3. MARQUEE ANNOUNCEMENT BAR
  // ========================================================

  function initMarquee() {
    var el = null;
    var selectors = [
      '.announcement-block',
      '#HdrAnnouncementBar .announcement-block',
      '.header-announcement-bar .announcement-block',
      '.announcement-bar__message',
      '.announcement-bar__text',
      '.announcement-bar p'
    ];

    for (var i = 0; i < selectors.length; i++) {
      el = document.querySelector(selectors[i]);
      if (el) break;
    }

    console.log('[ENGEL LOEWE] Marquee: element found:', !!el);
    if (!el) return;

    var text = el.textContent.trim();
    if (!text || text.length === 0) return;

    console.log('[ENGEL LOEWE] Marquee: text =', text.substring(0, 50) + '...');

    var wrapper = document.createElement('div');
    wrapper.className = 'el-marquee-wrapper';
    // Force display on marquee wrapper too
    forceStyle(wrapper, 'display', 'flex');

    for (var j = 0; j < 8; j++) {
      var item = document.createElement('span');
      item.className = 'el-marquee-item';
      item.textContent = text;
      forceStyle(item, 'display', 'inline');
      wrapper.appendChild(item);
    }

    el.textContent = '';
    el.style.overflow = 'hidden';
    el.style.whiteSpace = 'nowrap';
    el.style.display = 'block';
    el.style.width = '100%';
    el.appendChild(wrapper);

    console.log('[ENGEL LOEWE] Marquee: initialized successfully');
  }


  // ========================================================
  // 4. BACK TO TOP BUTTON
  // ========================================================

  function initBackToTop() {
    var btn = document.createElement('button');
    btn.id = 'el-back-to-top-btn';
    btn.innerHTML = '&#8593;';
    btn.setAttribute('aria-label', 'Back to top');
    document.body.appendChild(btn);

    // Force ALL styles via setProperty
    forceStyle(btn, 'display', 'flex');
    forceStyle(btn, 'position', 'fixed');
    forceStyle(btn, 'bottom', '40px');
    forceStyle(btn, 'right', '40px');
    forceStyle(btn, 'width', '44px');
    forceStyle(btn, 'height', '44px');
    forceStyle(btn, 'background', 'transparent');
    forceStyle(btn, 'border', '1px solid #C9A961');
    forceStyle(btn, 'color', '#C9A961');
    forceStyle(btn, 'font-size', '16px');
    forceStyle(btn, 'cursor', 'pointer');
    forceStyle(btn, 'z-index', '9998');
    forceStyle(btn, 'opacity', '0');
    forceStyle(btn, 'visibility', 'hidden');
    forceStyle(btn, 'transition', 'opacity 0.5s ease, visibility 0.5s ease, background-color 0.4s ease, color 0.4s ease');
    forceStyle(btn, 'align-items', 'center');
    forceStyle(btn, 'justify-content', 'center');
    forceStyle(btn, 'line-height', '1');
    forceStyle(btn, 'padding', '0');
    forceStyle(btn, 'margin', '0');
    forceStyle(btn, 'letter-spacing', '0');
    forceStyle(btn, 'box-sizing', 'border-box');

    console.log('[ENGEL LOEWE] Back to top: created with forced inline styles');

    var ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          if (window.scrollY > 600) {
            forceStyle(btn, 'opacity', '1');
            forceStyle(btn, 'visibility', 'visible');
          } else {
            forceStyle(btn, 'opacity', '0');
            forceStyle(btn, 'visibility', 'hidden');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    btn.addEventListener('mouseenter', function() {
      forceStyle(btn, 'background', '#C9A961');
      forceStyle(btn, 'color', '#FFFFFF');
    });

    btn.addEventListener('mouseleave', function() {
      forceStyle(btn, 'background', 'transparent');
      forceStyle(btn, 'color', '#C9A961');
    });
  }


  // ========================================================
  // 5. BANNER BUTTON HOVER ISOLATION
  // The image banner (.section-image-banner) has the entire
  // area as one link. There is no separate <button> element.
  // We detect when the mouse is over the visible "button" area
  // (the .banner-full-bleed-text .button element) and add a
  // hover class to style it.
  // ========================================================

  function initBannerButtonHover() {
    var bannerButtons = document.querySelectorAll('.section-image-banner .banner-full-bleed-text .button');
    console.log('[ENGEL LOEWE] Banner button hover: found', bannerButtons.length, 'buttons');

    bannerButtons.forEach(function(btn) {
      // The button is inside the link overlay, so pointer-events
      // are captured by the parent link. We listen on the parent
      // link and check if the mouse coordinates are within the
      // button's bounding box.
      var bannerSection = btn.closest('.section-image-banner');
      if (!bannerSection) return;

      var bannerLink = bannerSection.querySelector('.image-banner-full-banner-link');
      if (!bannerLink) bannerLink = bannerSection;

      bannerLink.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var isOver = (
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom
        );

        if (isOver && !btn.classList.contains('el-btn-hover')) {
          btn.classList.add('el-btn-hover');
        } else if (!isOver && btn.classList.contains('el-btn-hover')) {
          btn.classList.remove('el-btn-hover');
        }
      });

      bannerLink.addEventListener('mouseleave', function() {
        btn.classList.remove('el-btn-hover');
      });
    });
  }


  // ========================================================
  // 7. NAV GOLD UNDERLINE (via JS, not CSS)
  // The Mayfair theme adds .nav-desktop-dd-btn-hover class
  // permanently when dropdown is open, which keeps :hover
  // active on the parent <li>. CSS cannot distinguish between
  // real mouse hover and theme-class hover.
  // Solution: JS mouseenter/mouseleave directly on each <a>.
  // ========================================================

  function initNavGoldUnderline() {
    // Only on desktop
    if (window.innerWidth < 1025) return;

    // Target ALL top-level nav links in the desktop nav
    var navLinks = document.querySelectorAll('.hdr-nav-desktop .hdr-nav-primary-level-ul > li > a');
    console.log('[ENGEL LOEWE] Nav gold underline: found', navLinks.length, 'nav links');

    navLinks.forEach(function(link) {
      // Set initial border style
      forceStyle(link, 'border-bottom', '1px solid transparent');
      forceStyle(link, 'padding-bottom', '4px');
      forceStyle(link, 'transition', 'border-color 0.4s cubic-bezier(0.25, 0, 0.25, 1)');

      link.addEventListener('mouseenter', function() {
        forceStyle(link, 'border-bottom-color', '#C9A961');
      });

      link.addEventListener('mouseleave', function() {
        forceStyle(link, 'border-bottom-color', 'transparent');
      });
    });
  }


  // ========================================================
  // 6. SMOOTH PAGE TRANSITIONS
  // ========================================================

  function initPageTransitions() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;

      if (href.indexOf('http') === 0 && href.indexOf(window.location.hostname) === -1) return;
      if (href.charAt(0) === '#') return;
      if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (href.indexOf('javascript') === 0) return;
      if (link.getAttribute('target') === '_blank') return;
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (href.indexOf('admin') !== -1 || href.indexOf('password') !== -1) return;

      e.preventDefault();
      document.body.style.transition = 'opacity 0.4s cubic-bezier(0.25, 0, 0.25, 1)';
      document.body.style.opacity = '0';

      setTimeout(function() {
        window.location.href = href;
      }, 400);
    });

    console.log('[ENGEL LOEWE] Page transitions: initialized');
  }

})();